import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../firebase/firebase";
import { resolveWebsiteCatalogItem } from "./catalogImageVariants";

export const WORKFLOWS = {
  alterations: { title: "Alterations", eyebrow: "Perfect The Fit", description: "Choose Women, Men or Kids to explore alteration and repair services.", collection: "sections", childCollection: "alteration_services" },
  "dry-cleaning": { title: "Dry Cleaning & Pressing", eyebrow: "Garment Care", description: "Professional cleaning, pressing and express garment-care services.", collection: "drycleaning_service_categories", childCollection: "drycleaning_services" },
  pressing: { title: "Pressing & Ironing", eyebrow: "Garment Care", description: "Neat, crease-free pressing and ironing for everyday and occasion garments.", collection: "drycleaning_service_categories", childCollection: "drycleaning_services" },
  "fabric-store": { title: "Fabric Store", eyebrow: "Choose Your Fabric", description: "Browse active fabric categories and products from the shared StichB catalog.", collection: "fabric_categories", childCollection: "fabrics" },
  materials: { title: "Tailoring Materials", eyebrow: "Tools & Materials", description: "Shop tailoring materials, accessories and machine-service products.", collection: "materials", childCollection: null },
  "machine-services": { title: "Tailor Machine Services", eyebrow: "Machine Care", description: "Book repair, maintenance, cleaning, oiling and installation services.", collection: "machine_services", childCollection: null },
};

export function listenToWorkflowCollection(collectionName, onSuccess, onError) {
  return onSnapshot(collection(db, collectionName), (snapshot) => {
    const items = snapshot.docs.map((document) => {
      const data = document.data();
      return resolveWebsiteCatalogItem({
        id: document.id,
        ...data,
        imageUrl: data.websiteImageUrl || data.websiteDisplayImage || data.imageUrl || data.displayImage || data.image || "",
      });
    })
      .filter((item) => item.isActive !== false && item.active !== false)
      .sort((a, b) => Number(a.displayOrder || 0) - Number(b.displayOrder || 0));
    onSuccess(items);
  }, onError);
}
